var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpCreateDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5078 0.5H10.2578C4.73496 0.5 0.257812 4.97715 0.257812 10.5C0.257812 16.0228 4.73496 20.5 10.2578 20.5H10.5078C16.0307 20.5 20.5078 16.0228 20.5078 10.5C20.5078 4.97715 16.0307 0.5 10.5078 0.5Z",
    fill: "#4A90F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68428 15H7.22809C6.54983 15 6 14.4403 6 13.75L6.00005 6.25C6.00005 5.55964 6.54989 5 7.22814 5H12.7547C13.433 5 13.9828 5.55965 13.9828 6.25V9.68751M13.2632 14.7856V13.0178M13.2632 13.0178V11.25M13.2632 13.0178L11.5264 13.0178M13.2632 13.0178L15 13.0178M8.14936 7.50001H11.8336M8.14936 9.37501H11.8336M8.14936 11.25H9.9915",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpCreateDoc);
export default __webpack_public_path__ + "static/media/op-create-doc.b237c2cd78bfd96979ede4b1385bb96b.svg";
export { ForwardRef as ReactComponent };